var exports = {
  "kL": "NoteEditSheet.module__container___TV9TQm",
  "Gv": "NoteEditSheet.module__backButton___TV9TQm",
  "j2": "NoteEditSheet.module__backIcon___TV9TQm",
  "eG": "NoteEditSheet.module__saveButton___TV9TQm",
  "AW": "NoteEditSheet.module__saveButtonActive___TV9TQm",
  "Qs": "NoteEditSheet.module__content___TV9TQm",
  "Pf": "NoteEditSheet.module__label___TV9TQm",
  "PC": "NoteEditSheet.module__textarea___TV9TQm",
};

module.exports = exports;
